export default __webpack_public_path__ + "static/media/he-is-a-boy.0f41808e.mp3";